import axios from './axios';

/**
 * Loads a emergency numbers
 */
export const getEmergencyContacts = () => axios.get('/schools/current/phone/numbers');

export const getPupilContact = contactId => axios.get(`/pupilcontacts/${contactId}`);

export const createPupilContact = contacts => axios.post(`/pupilcontacts`, contacts);

export const updatePupilContact = contact => axios.put(`/pupilcontacts/${contact.id}`, contact);

export const deletePupilContact = ({ pupilId, contact }) =>
  axios.delete(`/pupils/${pupilId}/contacts/${contact.id}`);

export const linkPupilContact = ({ pupilId, contact }) =>
  axios.put(`/pupils/${pupilId}/contacts/${contact.id}`, {
    extId: contact.extId,
    fullName: contact.fullName,
    phone: contact.phone,
    mobilePhone: contact.mobilePhone,
    sosContact: contact.sosContact,
    email: contact.email,
    relationshipRaw: contact.relationshipRaw,
  });
